export enum FilterMapping {
    opportunityCreationDateFrom = 'opportunityCreationDate.from',
    opportunityCreationDateTo = 'opportunityCreationDate.to',
    opportunityCreationDateIncludeNull = 'opportunityCreationDate.includeEmpty',
    opportunityDueDateFrom = 'opportunityDueDate.from',
    opportunityDueDateTo = 'opportunityDueDate.to',
    opportunityDueDateIncludeNull = 'opportunityDueDate.includeEmpty',
    projectStartDateFrom = 'projectStartDate.from',
    projectStartDateTo = 'projectStartDate.to',
    projectStartDateIncludeNull = 'projectStartDate.includeEmpty',
    projectEndDateFrom = 'projectEndDate.from',
    projectEndDateTo = 'projectEndDate.to',
    projectEndDateIncludeNull = 'projectEndDate.includeEmpty',
    potentialValueFrom = 'potentialValue.from',
    potentialValueTo = 'potentialValue.to',
    probabilityValueFrom = 'probabilityValue.from',
    probabilityValueTo = 'probabilityValue.to',
    expectedResponseDateTo = 'expectedResponseDate.to',
    expectedResponseDateFrom = 'expectedResponseDate.from',
    expectedResponseDateIncludeNull = 'expectedResponseDate.includeEmpty',
    bidDateFrom = 'bidDate.from',
    bidDateTo = 'bidDate.to',
    bidAmountFrom = 'bidAmount.from',
    bidAmountTo = 'bidAmount.to',
    awardedDateFrom = 'awardedDate.from',
    awardedDateTo = 'awardedDate.to',
    awardedAmountFrom = 'awardedAmount.from',
    awardedAmountTo = 'awardedAmount.to',
    projectDueDateFrom = 'projectDueDate.from',
    projectDueDateTo = 'projectDueDate.to',
    sellPriceFrom = 'sellPriceValue.from',
    sellPriceTo = 'sellPriceValue.to'
}

export const mapping: Record<string, string> = FilterMapping;
